import {
  SavingsCycleCancelReason,
  SavingsCycleState,
  SavingStatus,
  SavingStatusReasonType,
  SavingType,
} from '@aslanpay/portal-common-lib';

export const SavingTypeLabels: Record<SavingType, string> = {
  FLEXIBLE_SAVER: 'Flexible Saver',
  CHALLENGE: 'Savings Challenge',
};

export const SavingStatusValues: Record<SavingStatus, { color: string; value: string }> = {
  NOT_STARTED: { color: 'registered', value: 'Not started' },
  IN_PROGRESS: { color: 'active', value: 'In progress' },
  PAUSED: { color: 'warning', value: 'Paused' },
  COMPLETED: { color: 'created', value: 'Completed' },
  STOPPED: { color: 'paused', value: 'Stopped' },
  CANCELLED: { color: 'paused', value: 'Cancelled' },
  ARCHIVED: { color: 'paused', value: 'Archived' },
};

export const ActiveSavingStatuses: SavingStatus[] = ['IN_PROGRESS', 'PAUSED', 'NOT_STARTED'];

export const SavingStatusReasonLabels: Record<SavingStatusReasonType, string> = {
  CREATED: 'Created',
  STARTED: 'Started',
  RESUMED: 'Resumed',
  RESUMED_LEAVE_REVERTED: 'Resumed after leave was reverted',
  PAUSED_EMPLOYER: 'Paused by the employer',
  PAUSED_ASLAN: 'Paused by Aslan',
  PAUSED_LEAVE_PROCESSED: 'Paused while on leave',
  COMPLETED: 'Completed',
  COMPLETED_SKIPPED_FINAL_CYCLE: 'Completed, final cycle skipped',
  STOPPED_BY_USER: 'Stopped by the employee',
  LEAVER_STOPPED: 'Stopped as a leaver',
  STOPPED_ON_CALENDAR_CHANGE: 'Stopped on pay calendar change',
  STOPPED_BEFORE_FIRST_SAVE: 'Stopped before the first save',
  CANCELLED_BY_USER: 'Cancelled by the employee',
  ARCHIVED_ON_EMPTY: 'Archived when emptied',
};

export const SavingsCycleCancelReasonLabels: Record<SavingsCycleCancelReason, string> = {
  INSUFFICIENT_FUNDS: 'Insufficient funds',
  CANCELLED_BY_USER: 'Cancelled by the employee',
  SAVINGS_MODULE_DISABLED: 'Savings module disabled',
  LEAVER: 'Leaver',
  CALENDAR_CHANGE: 'Pay calendar change',
};

export const SavingsCycleStateLabels: Record<SavingsCycleState, string> = {
  ACCRUED: 'Accrued',
  CREDITED: 'Credited',
  CANCELLED: 'Cancelled',
  FORFEITED: 'Forfeited',
};
